/**
 * home
 */
 import banner_1 from '../../assets/img/aboveTheFold/banner_1.png';
 import banner_2 from '../../assets/img/aboveTheFold/banner_2.png';


import servicesSwiperImgBg from '../../assets/img/servicesSwiper/img_bg.png';
import servicesSwiperImg1 from '../../assets/img/servicesSwiper/img_1.png';
import servicesSwiperImg2 from '../../assets/img/servicesSwiper/img_2.png';
import servicesSwiperImg3 from '../../assets/img/servicesSwiper/img_3.png';

import ourAdvantagesBgImg01 from '../../assets/img/ourAdvantages/img_01_3x.png';
import ourAdvantagesBgImg02 from '../../assets/img/ourAdvantages/img_02_3x.png';
import ourAdvantagesBgImg03 from '../../assets/img/ourAdvantages/img_03_3x.png';

import union1 from '../../assets/img/icons/union_1.svg';
import union2 from '../../assets/img/icons/union_2.svg';
import union3 from '../../assets/img/icons/union_3.svg';
import union4 from '../../assets/img/icons/union_4.svg';
import union5 from '../../assets/img/icons/union_5.svg';
import union6 from '../../assets/img/icons/union_6.svg';

import casesImg1 from '../../assets/img/cases/img_1.jpg';
import casesImg2 from '../../assets/img/cases/img_2.jpg';
import casesImg3 from '../../assets/img/cases/img_3.jpg';
import casesImg4 from '../../assets/img/cases/img_4.jpg';
import casesImg5 from '../../assets/img/cases/img_5.jpg';
import casesImg6 from '../../assets/img/cases/img_6.jpg';
import casesImg7 from '../../assets/img/cases/img_7.jpg';
import casesImg8 from '../../assets/img/cases/img_8.jpg';
import casesImg9 from '../../assets/img/cases/img_9.jpg';
import casesImg10 from '../../assets/img/cases/img_10.jpg';
import casesImg11 from '../../assets/img/cases/img_11.jpg';

// global config file start
const {
  websiteRecord, // 网站备案/版权
  companyName, // 公司名字
  abbreviation, // 简称->中文
  companyAddress,  // 公司地址->中文
  contactInformation, // 联系方式
  mapInfo, // 地图位置
} = window.globalConfig;
// global config file end

const zhCN = {
  'lang': '中文',
  home: {
    aboveTheFoldList: [
      {
        id: 1001,
        title: '用心服务好每一位客户',
        desc: '活动策划 / 公关传播 / 数字影视',
        img: banner_1,
      },
      {
        id: 1002,
        title: '专注品质活动展会策划',
        desc: '活动策划 / 公关传播 / 数字影视',
        img: banner_2,
      }
    ],
    entertainment:{
      leftContent: {
        title: companyName.fullNameZH,
        subTitle: '提供各类活动策划、广告布置、活动餐饮和影视制作服务',
        desc: '成立于2019年',
        list: [
          {
            id: 1001,
            desc: `${abbreviation.abbreviationZH}拥有兼具战略理念与实战经验的创意团队，高效灵活的执行团队，规范成熟的项目管控机制，提供从策划、设计到执行环环相扣的全方位服务，力求带给客户最专业、最前沿、最实效的活动服务。`,
          },
          {
            id: 1002,
            desc: '多年来我们为众多中小企业设计全年各类型活动，已承接多场活动策划及运营管理，让每一个客户都获得了超高品质的服务，受到多个客户的友好评价。',
          },
          {
            id: 1003,
            desc: '未来，我们期待能够与您一起创造更多的辉煌。',
          },
        ] 
      },
      rightContent: {
        textList: [
          {
            id: 1001,
            title: '行业经验',
            number: '4',
            desc: '年',
          },
          {
            id: 1002,
            title: '全程跟进',
            number: '1V1',
            desc: '',
          },
          {
            id: 1003,
            title: '用心服务',
            number: '100',
            desc: '%',
          },
        ] 
      }
    },
    servicesSwiperList: [
      {
        id: 1001,
        bg: servicesSwiperImgBg,
        img: servicesSwiperImg1,
        coloValue: ['#0A3DBE', '#FAFAFE', '#0A3DBE'],
        headTop: {
          title: '我们的服务',
          subTitle: '更高效、更省心、更专业',
        },
        title: '活动策划',
        subTitle: '专业团队，专业服务​',
        descList: [
          {
            id: 1001,
            text: '为企业提供，囊括对外的市场活动，以及对内的行政活动的策划方案。'
          },
          {
            id: 1002,
            text: '我们秉承“创意致胜”以及“精细化运营”的活动策划理念，以创造性思维打造与众不同的活动方案，通过差异化作品彰显客户品牌个性。'
          },
        ],
        strongLisg: [
          {
            id: 1001,
            text: '生日派對/圣诞节/会议论坛/酒会晚宴',
          },
          {
            id: 1002,
            text: '年会庆典/签约仪式/开工开盘',
          }
        ],
        textList: [
          {
            id: 1001,
            title: '创意策划：',
            text: '融合企业品牌特色，量身定制活动方案，筛选推荐最佳场地。',
          },
          {
            id: 1002,
            title: '舞美设计：',
            text: '现场勘查场地，结合活动方案进行合理布局规划。',
          },
          {
            id: 1003,
            title: '演艺资源：',
            text: '提供舞蹈、唱歌、魔术、小品、双语主持等各类型演艺资源。',
          },
          {
            id: 1004,
            title: '会场布置：',
            text: '专业技术施工团队，提供从设备安装、使用、维护到撤场全过程满意的服务。',
          },
          {
            id: 1005,
            title: '现场管理：',
            text: '活动现场全程把控，细致严谨的彩排，全方位应急预案确保活动万无一失。',
          },
          {
            id: 1006,
            title: '视频制作：',
            text: '立足企业文化，围绕活动主题，针对活动现场拍摄、宣传片制作。',
          },
        ]
      },
      {
        id: 1002,
        bg: servicesSwiperImgBg,
        img: servicesSwiperImg2,
        coloValue: ['#E24C38', '#FAFAFE', '#E24C38'],
        headTop: {
          title: '我们的服务',
          subTitle: '更高效、更省心、更专业',
        },
        title: '活动餐饮',
        subTitle: '环球美食，品味世界',
        descList: [
          {
            id: 1001,
            text: '以客户的健康安全放在首位，提供客户所需之专业中西式外烩料理、精緻茶会点心、港式小点、会议点心、各式酒会、开幕茶会及摆设服务，将您的活动更添风采。'
          },
        ],
        strongLisg: null,
        textList: [
          {
            id: 1001,
            title: '专人跟进：',
            text: '专责人员与您洽谈餐饮及活动安排需要，沟通清晰，协作无间。',
          },
          {
            id: 1002,
            title: '创新经典：',
            text: '多元化中、西菜式及创意Fusion餐点，提供选择变化无穷。',
          },
          {
            id: 1003,
            title: '量身定制：',
            text: '专业主厨料理按客户个人喜好、品味或企业文化、活动场地环境、餐饮预算及食品类型要求等，量身定制特色餐点。',
          },
          {
            id: 1004,
            title: '内外兼备：',
            text: '周全到会设备，充裕服务人手，满足室内及室外活动场地不同需求。',
          },
          {
            id: 1005,
            title: '增值服务：',
            text: '配合客户需求，提供活动现场趣味点子，增添欢乐气氛；更可提供场地佈置、现场摄影、短片拍摄。',
          },
        ]
      },
      {
        id: 1003,
        bg: servicesSwiperImgBg,
        img: servicesSwiperImg3,
        coloValue: ['#7C31C7', '#FAFAFE', '#7C31C7'],
        headTop: {
          title: '我们的服务',
          subTitle: '更高效、更省心、更专业',
        },
        title: '影视制作',
        subTitle: '更懂企业，更懂营销',
        descList: [
          {
            id: 1001,
            text: '拥有丰富的影视制作经验，更懂客户要什么。'
          },
          {
            id: 1002,
            text: '我们专注高端创意策划，拍摄和后期制作，恪守专业视频制作作业模式，注重商业时效性和视觉艺术性的结合，为企业提供有价值的视频服务。'
          },
        ],
        strongLisg: [
          {
            id: 1001,
            text: '企业宣传/2D动画',
          },
          {
            id: 1002,
            text: '3D动画/活动录制',
          }
        ],
        textList: [
          {
            id: 1001,
            title: '效果保证：',
            text: '前期策划、中期拍摄、后期剪辑、设计、特效制作的全流程执行团队。',
          },
          {
            id: 1002,
            title: '经验丰富：',
            text: '积累了丰富的项目操作和管理经验，确保每个项目完美落地。',
          },
          {
            id: 1003,
            title: '拍摄设备：',
            text: '专业摄制器材，让影片在同行中脱颖而出。',
          },
          {
            id: 1004,
            title: '服务承诺：',
            text: '1V1项目经理全程跟踪项目，提供免费多时长版本剪辑。',
          },
        ]
      },
    ],
    ourAdvantages: {
      title: '我们的优势',
      subTitle: '领先同行，想你所想',
      list: [
        {
          id: '01',
          img: ourAdvantagesBgImg01,
          title: '海量资源',
          desc: '为客户提供多种酒店、特色场地、演艺表演人才、各式餐点选择。',
        },
        {
          id: '02',
          img: ourAdvantagesBgImg02,
          title: '设备器材',
          desc: '配备专业摄影机、无人机等主流摄影设备。',
        },
        {
          id: '03',
          img: ourAdvantagesBgImg03,
          title: '团队实力',
          desc: '核心成员经验丰富，为您提供满意放心的执行保障。',
        }
      ],
      flowNums: {
        title: '服务流程',
        subTitle: '我们的服务规范且细致',
        list: [
          {
            num: '01',
            icon: union1,
            name: '需求洽谈',
          },
          {
            num: '02',
            icon: union2,
            name: '实地勘测',
          },
          {
            num: '03',
            icon: union3,
            name: '定制方案',
          },
          {
            num: '04',
            icon: union4,
            name: '现场布置',
          },
          {
            num: '05',
            icon: union5,
            name: '落地执行',
          },
          {
            num: '06',
            icon: union6,
            name: '项目总结',
          },
        ]
      }
    },
    casesInfo: {
      title: '案例',
      subTitle: '为客户创造价值，与客户共同发展',
      desc: '年会晚会/节庆活动/活动广告布置/开业典礼/酒会策划',
      list: [
        { id: 1001, img: casesImg1 },
        { id: 1002, img: casesImg2 },
        { id: 1003, img: casesImg3 },
        { id: 1004, img: casesImg4 },
        { id: 1005, img: casesImg5 },
        { id: 1006, img: casesImg6 },
        { id: 1007, img: casesImg7 },
        { id: 1008, img: casesImg8 },
        { id: 1009, img: casesImg9 },
        { id: 1010, img: casesImg10 },
        { id: 1011, img: casesImg11 },
      ]
    },
    contacts: {
      title: '联系我们',
      subTitle: '立即致电，将有专人为您服务',
      mapName: mapInfo.nameZH,
      mapAddress: mapInfo.map,
      list: [
        {
          id: 1001,
          name: '工作时间',
          desc: `周一～周六9:00~18:00`
        },
        {
          id: 1002,
          name: '公司地址',
          desc: companyAddress.addressZH
        },
        {
          id: 1003,
          name: '电话',
          desc: contactInformation.tel
        },
        {
          id: 1004,
          name: 'E-mail',
          desc: contactInformation.mail
        },
      ]
    },
    website: websiteRecord.copyrightZH,
  },
 
};

export default zhCN;
